<section class="Modal-Global ModalProAnnexeFIN" id="ModalPropertiesAnnexeFIN">
  <div class="wrapper">
    <div class="Pro-popupAnnexeFIN popup">
      <div class="Pro-insideAnnexeFIN popup-inside">
        <div class="Pro-backgroundsAnnexeFIN backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>

      <form [formGroup]="formAnnexe" (ngSubmit)="UpdatePropertiesAnnexeFIN()">
        <div class="Pro-contentAnnexeFIN content">
          <button
            (click)="ToggleModalPropertiesAnnexeFIN(false)"
            type="button"
            class="Btn-Close"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
          <div class="Content-Top">
            <h2>Propiedades de Anexo</h2>
            <h4>
              Modifica las propiedades del anexo {{ FILE_FIN_Properties.Name }}
            </h4>
          </div>

          <div class="Content-body Form-Properties">
            <div class="Content-grid-2">
              <div class="Text-icon">Nombre de Anexo</div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-solid fa-qrcode"></i
                ><input
                  id="IdinputNamePropAnnexeFIN"
                  type="text"
                  formControlName="Name"
                  placeholder="Nombre del Procedimiento…"
                />
              </div>
            </div>
          </div>

          <div class="Container-Progress" id="Content-Progress-Update">
            <div class="ProgressBar" id="Progress-Bar-Update"></div>
          </div>
          <div class="Content-Bottom Content-Bottom-Properties">
            <button type="submit" class="Btn-LSave-Form Btn-Save-Modal">
              <i class="icon-send material-icons" id="Send-Icon-Update">send</i>
              <i class="icon-check material-icons" id="Check-Icon-Update"
                >check</i
              >
              <span class="Btn-Save-Modal-text" id="Text-Btn-Update"
                >Guardar Cambios</span
              >
            </button>
            <button
              type="button"
              (click)="ToggleModalPropertiesAnnexeFIN(false)"
              class="Btn-LCancel-Form Btn-Close-Modal"
            >
              <span>Cerrar</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>
